
export default {
    components: {},
    props: {
        employee: {
            type: Object,
            required: true
        },
    },
    created() {
        let t = this;

        t.dict.hire_type = listToDict(t.options.hire_type);
        t.dict.hire_year = listToDict(t.options.hire_year);
        t.dict.rest_day = listToDict(t.options.rest_day);

        t.options.rest_day[5].selected = true;
        t.options.rest_day[6].selected = true;

        t.f.static_rest_day = [
            t.options.rest_day[5],
            t.options.rest_day[6]
        ];

        let arr = [];

        t.f.static_rest_day.forEach(item => {
            arr.push(item.text);
        });

        t.f.static_rest_day_text = arr.join('、');

        t.loadData();
    },
    activated() {
        let t = this;
    },
    methods: {
        loadData() {
            let t = this;

            axios.get('unit').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.text = item.name;
                    });
                    t.options.unit = arr;
                    t.dict.unit = listToDict(arr);
                }
            });


            axios.get('employeeConfig?employee_id=' + t.employee.id).then(res => {

                if (res.data.status == 1) {

                    let config = res.data.options.items[0];

                    if (config) {

                        t.config = config;

                        if (config.att_config) {
                            config.att_config = JSON.parse(config.att_config);
                        }

                        let days = config.static_rest_day.split(',');

                        if (days.length > 0) {

                            t.f.static_rest_day.forEach(item => {
                                item.selected = false;
                            });
                            t.f.static_rest_day = [];
                            t.f.static_rest_day_text = '';

                            let arr = [];
                            let arr2 = [];

                            days.forEach(day => {
                                if (t.dict.rest_day[day]) {
                                    t.dict.rest_day[day].selected = true;
                                    arr.push(t.dict.rest_day[day]);
                                    arr2.push(t.dict.rest_day[day].text);
                                }
                            });

                            config.static_rest_day_text = arr2.join('、');

                            config.static_rest_day = arr;
                        }

                        mirror(config, t.f);

                    }
                }
            });

        },
        onSelectHireType(e) {
            this.f.hire_type = e.id;
        },
        onSelectUnit(e) {
            this.f.unit_id = e.id;
        },
        onSelectHireYear(e) {
            this.f.hire_year = e.id;
        },
        openPopover(e) {
            console.log(e);
        },
        addAtt() {
            this.f.att_config.push({
                start: '00:00',
                end: '00:00',
                showStart: false,
                showEnd: false,
                tomorrow: false
            });
        },
        removeAtt(item) {
            this.f.att_config.remove(item);
        },
        selectDay(item) {

            let t = this;

            if (item.selected) {
                item.selected = false;
                t.f.static_rest_day.remove(item);
            }
            else {
                item.selected = true;
                t.f.static_rest_day.push(item);
            }

            let arr = [];

            t.f.static_rest_day.forEach(item => {
                arr.push(item.text);
            });

            t.f.static_rest_day_text = arr.join('、');
        },
        startUpload(field) {

            let t = this;

            FileUploader.onSelectFile = file => {

                if (t.busying)
                    return;

                t.busying = true;

                const formData = new FormData();

                formData.append('file', file);

                axios.post('employeeConfig/saveFile', formData, {
                    headers: {
                    }
                }).then(res => {

                    t.busying = false;

                    if (res.data.options.file_url)
                        t.f[field] = res.data.options.file_url;

                }).catch(error => {

                    t.busying = false;

                });

            };

            FileUploader.openSelector();

        },

        saveConfig() {

            let t = this;

            if (t.busying)
                return;


            let form = mirror(t.f);

            form.employee_id = t.employee.id;

            let arr = [];
            form.static_rest_day.forEach(day => {
                arr.push(day.id);
            });

            form.static_rest_day = arr.join(',');
            delete form.static_rest_day_text;

            if (form.att_config.length < 1) {
                A.err('少なくとも一つの出退勤時間範囲を指定してください。');
                return;
            }

            let go = true;

            form.att_config.forEach((att, i) => {
                let d1 = new Date('2025-01-01 ' + att.start).valueOf();
                let d2 = new Date('2025-01-01 ' + att.end).valueOf();

                if (d1 >= d2 && !att.tomorrow) {
                    go = false;
                    A.err('出退勤_' + t.pad2(i + 1) + '「' + att.start + '-' + att.end + '」<br>出退勤の時間範囲が正しくありません。');
                }
            });

            if (!go) {
                return;
            }

            let attConfig = JSON.parse(JSON.stringify(form.att_config));

            let newAttConfig = [];

            attConfig.forEach(att => {
                newAttConfig.push({
                    start: att.start,
                    end: att.end,
                    tomorrow: att.tomorrow ? 1 : 0,
                });
            });

            form.att_config = JSON.stringify(newAttConfig);

            if (form.id) {
                function _save() {
                    t.busying = true;
                    axios.put('employeeConfig/' + form.id, form).then(res => {
                        t.busying = false;

                        if (res.data.status == 1) {
                            t.loadData();
                            A.toast('変更が保存されました。');
                        }
                    });
                }
                if (t.config && form.static_rest_day != t.config.static_rest_day) {
                    A.safety('定休日の変更は今月に反映されませんので、ご注意ください。<br><br>来月のシフトは自動的にリセットされるので、ご注意ください。').then(res => {
                        if (res.isConfirmed) {
                            form.static_rest_day_changed = 1;
                            _save();
                        }
                    });
                }
                else {
                    _save();
                }
            }
            else {

                t.busying = true;

                axios.post('employeeConfig', form).then(res => {
                    t.busying = false;

                    if (res.data.status == 1) {
                        t.loadData();
                        A.toast('変更が保存されました。');
                    }
                });
            }
        },
        onSelectTomorrow(att) {
            if (att.tomorrow) {
                let arr = att.end.split(':');
                let hour = Number(arr[0]);
                if (hour > 10) {
                    att.end = '10:' + arr[1];
                }
            }
        }
    },
    data() {
        return {
            busying: false,

            config: null,

            f: {
                work_online: 0,
                unit_id: null,
                hire_type: 1,
                hire_year: 1,
                att_config: [
                    {
                        start: '00:00',
                        end: '00:00',
                        showStart: false,
                        showEnd: false,
                    }
                ],
                static_rest_day: [],
                static_rest_day_text: '',
                year_rest_day: 7,
                monthly_dynamic_rest_day: 8,
                monthly_att_modify_times: 6,
                monthly_field_work_times: 14,
                contract_url: "",
                insurance_url: "",
                remark: "",
            },

            dict: {
                hire_type: {},
                hire_year: {},
                rest_day: {},
                unit: {}
            },

            p: {
                hire_type: false,
                hire_year: false,
                rest_day: false,
                static_rest_day: false,
            },
            options: {
                hire_type: [
                    { id: 1, text: "正社員" },
                    { id: 2, text: "バイト" },
                ],
                hire_year: [
                    { id: 1, text: "1年" },
                    { id: 2, text: "2年" },
                    { id: 3, text: "3年" },
                    { id: 4, text: "4年" },
                    { id: 5, text: "5年" },
                    { id: 99, text: "無期限" },
                ],
                rest_day: [
                    { id: 1, text: "月" },
                    { id: 2, text: "火" },
                    { id: 3, text: "水" },
                    { id: 4, text: "木" },
                    { id: 5, text: "金" },
                    { id: 6, text: "土" },
                    { id: 0, text: "日" },
                ],
                unit: []
            },
        };
    },
    computed: {},
};
